import {dekad_obj} from './ChatTimeSeries.js'
import './styles/MapStyle.css'

const InfoAnalysis = ({show_generate_report, admin_details, setShow_generate_report}) => {
  return (
    <div className='info-analysis'>
      
        {show_generate_report && admin_details &&(
            <div className="columns is-flex has-text-left">
              <div className="close-button" onClick={() => setShow_generate_report(false)}>
            X
             </div >
              <div className="column is-half">
                {show_generate_report && (
                  <div className=''>
                    <p className='is-size-7  has-text-weight-semibold admin-text ml-1'>{admin_details.africa_region} Boundary </p>
                    <p className="admin-text has-text-weight-light is-size-7 ml-1 is-outlined">
                    
                      Country : {admin_details.country} 
                      <br />
                      Admin Level One Name : {admin_details.region}
                      <br />
                      
                    </p>
                    <p className="admin-text has-text-weight-light ml-1 data-params mt-1">
                    Data Params : {admin_details.year} {admin_details.month}, Dekad {admin_details.dekad}
                    </p>

                    <div className='column is-centered is-flex is-justify-content-left'>
                    <a
                      href={`/reporting?year=${admin_details["year"]}&month=${
                        admin_details["month"]
                      }&dekad=${dekad_obj[admin_details["dekad"]]}&adminZeroCode=${admin_details?.country_code}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="button  is-medium is-rounded is-size-6 ml-5"
                      style={{ marginBottom: "2px",  backgroundColor:'#3364CC', color:'white', height:'2rem'}}
                    >
                      Generate Report
                    </a>{" "}
                    </div>

                   
                  </div>
                )}
                
              </div>
            </div>
          )}
      
    </div>
  )
}

export default InfoAnalysis
